import { render, staticRenderFns } from "./goodsMin.vue?vue&type=template&id=3e4ee8d8&scoped=true"
import script from "./goodsMin.vue?vue&type=script&lang=js"
export * from "./goodsMin.vue?vue&type=script&lang=js"
import style0 from "./goodsMin.vue?vue&type=style&index=0&id=3e4ee8d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4ee8d8",
  null
  
)

export default component.exports